import RichTextEditor from '../../components/editor/RichTextEditor';

function DetailValue({ value, isHtml = false }) {
  if (!value?.trim()) {
    return <span className="site-message-view__empty">未設定</span>;
  }
  if (isHtml) {
    return <div className="site-message-view__html" dangerouslySetInnerHTML={{ __html: value }} />;
  }
  return <span>{value}</span>;
}

export default function SiteMessageViewModal({ open, title, data, onClose }) {
  if (!open || !data) {
    return null;
  }

  return (
    <div className="confirm-dialog-overlay" role="presentation" onClick={onClose}>
      <div
        className="modal-panel modal-panel--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-panel__header">
          <h3>{title}</h3>
          <button type="button" className="btn btn-link" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-panel__body site-message-view">
          {data.memberId != null ? (
            <div className="site-message-view__row">
              <span className="site-message-view__label">用戶ID</span>
              <DetailValue value={String(data.memberId)} />
            </div>
          ) : null}
          {data.sendType != null ? (
            <div className="site-message-view__row">
              <span className="site-message-view__label">群發類型</span>
              <DetailValue value={data.sendTypeLabel} />
            </div>
          ) : null}
          {data.status != null ? (
            <div className="site-message-view__row">
              <span className="site-message-view__label">狀態</span>
              <DetailValue value={data.statusLabel} />
            </div>
          ) : null}
          <div className="site-message-view__row">
            <span className="site-message-view__label">圖片連結</span>
            <DetailValue value={data.imgUrl} />
          </div>
          <div className="site-message-view__row">
            <span className="site-message-view__label">影片連結</span>
            <DetailValue value={data.filmUrl} />
          </div>

          {(data.details || []).map((detail) => (
            <section key={detail.lang} className="site-message-lang-section">
              <h4 className="site-message-view__section-title">標題（{detail._label || detail.lang}）</h4>
              <DetailValue value={detail.title} />
              <h4 className="site-message-view__section-title">內容（{detail._label || detail.lang}）</h4>
              <DetailValue value={detail.body} isHtml />
            </section>
          ))}
        </div>

        <div className="modal-panel__footer admin-modal__footer--center">
          <button type="button" className="btn btn-danger" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
